import React from "react";
import MetricDisplay from "./MetricDisplay";

/**
 * KpiValue — single helper for every KPI number in the app.
 *
 * Two render states (demo path removed — boardroom is real-data only):
 *   1. Active customer + real data        → formatted real value.
 *   2. Active customer + NO data / loading → dash + info-icon + tooltip
 *                                            via MetricDisplay.
 *
 * Pass either:
 *   - `realValue` (number) + `format` ("currency" | "percentage" | "days" | "number")
 *     for numeric Tally-backed KPIs.
 *   - or `realText` (string) when a string makes more sense (e.g. "Top 18%").
 */
export default function KpiValue({
  realValue = null,
  realText = null,
  format = "currency",
  label,
  tooltip,
  size = "large",
  isLoading,
  dataAvailable,
  testId,
}) {
  // String KPI with real data.
  if (realText !== null && realText !== undefined && dataAvailable) {
    return (
      <span
        data-testid={testId || `kpi-real-${(label || "").replace(/\s+/g, "-").toLowerCase()}`}
        className={
          size === "large"
            ? "text-[22px] font-bold text-[#0F1B2D]"
            : size === "medium"
            ? "text-[18px] font-bold text-[#0F1B2D]"
            : "text-[14px] font-semibold text-[#0F1B2D]"
        }
      >
        {realText}
      </span>
    );
  }

  // Numeric Tally-backed KPI (or "—" when value missing).
  return (
    <MetricDisplay
      value={realValue}
      format={format}
      label={label}
      tooltipText={tooltip}
      size={size}
      isLoading={isLoading}
      testId={testId}
    />
  );
}
